import { render, staticRenderFns } from "./AreaTreeSelect.vue?vue&type=template&id=804e819a&scoped=true"
import script from "./AreaTreeSelect.vue?vue&type=script&lang=ts"
export * from "./AreaTreeSelect.vue?vue&type=script&lang=ts"
import style0 from "./AreaTreeSelect.vue?vue&type=style&index=0&id=804e819a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e819a",
  null
  
)

export default component.exports